import React, { useEffect, useState } from 'react';
import Navbar from './Navbar/Navbar';
import Sidebar from './Sidebar/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { fetchUserAction } from '../../utils/redux/auth/authActions';
import { setAuthorizationToken } from '../../utils/api-service/api-service';
import './Layout.css';
import { canAccessRoute } from '../../utils/auth/permissions';

const PermissionGate = ({ children }) => {
    const { user } = useSelector(state => state.auth);
    const location = useLocation();

    // Layout has already verified the user is logged in before rendering this.
    // Here we only check permissions.
    if (user && !canAccessRoute(user, location.pathname)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

const Layout = ({ children }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const returnJWT = async () => {
        let token = await Cookies.get('jwt');
        return token || null;
    }

    const auth = async () => {
        const isAuthenticated = await returnJWT();
        if (isAuthenticated) {
            setAuthorizationToken(isAuthenticated);
            await dispatch(fetchUserAction());
        } else {
            navigate('/login')
        }
        setLoading(false)
    }

    useEffect(() => {
        auth();
    });

    if (loading) return <>LOADING...</>;


    return (
        <div className="layout-container">
            <Navbar />
            <div className="main-content">
                <Sidebar />
                <div className="page-content">
                    <PermissionGate>
                        <Outlet />
                    </PermissionGate>
                </div>
            </div>
        </div>
    );
};

export default Layout;